import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { InsightKey } from "@tandemdiabetes/sugarmate-api-react-client"

const upToNow = null
const sixHours = 6
const oneDay = 24
const oneWeek = 7 * 24
const ninetyDays = 90 * 24

export function copyDefaultInsightRangeByKey(): Record<
  InsightKey,
  Insight["range"]
> {
  return {
    [InsightKey.ExerciseAverageDuration]: oneWeek,
    [InsightKey.ExerciseTotalDuration]: oneDay,
    [InsightKey.FoodAverageCalories]: oneWeek,
    [InsightKey.FoodAverageCarbs]: oneWeek,
    [InsightKey.FoodAverageFat]: oneWeek,
    [InsightKey.FoodAverageFiber]: oneWeek,
    [InsightKey.FoodAverageProtein]: oneWeek,
    [InsightKey.FoodTotalCalories]: oneDay,
    [InsightKey.FoodTotalCarbs]: oneDay,
    [InsightKey.FoodTotalFat]: oneDay,
    [InsightKey.FoodTotalFiber]: oneDay,
    [InsightKey.FoodTotalProtein]: oneDay,
    [InsightKey.LiquidTotal]: oneDay,
    [InsightKey.LiquidAverage]: oneWeek,
    [InsightKey.GlucoseAverageReadingBedtime]: oneWeek,
    [InsightKey.GlucoseAverageReadingWakeUp]: oneWeek,
    [InsightKey.GlucoseAverageReading]: oneDay,
    [InsightKey.GlucoseCoefficientOfVariation]: oneWeek,
    [InsightKey.GlucoseFluxGrade]: oneDay,
    [InsightKey.GlucoseHighsAndLows]: oneWeek,
    [InsightKey.GlucoseManagementIndicator]: ninetyDays,
    [InsightKey.GlucoseMedianReading]: oneDay,
    [InsightKey.GlucosePercentageAbove]: oneDay,
    [InsightKey.GlucosePercentageBelow]: oneDay,
    [InsightKey.GlucosePercentageDistribution]: oneDay,
    [InsightKey.GlucosePercentageWithin]: oneDay,
    [InsightKey.GlucoseQuartiles]: oneWeek,
    [InsightKey.GlucoseStandardDeviation]: oneWeek,
    [InsightKey.GlucoseTotalUnicorns]: oneDay,
    [InsightKey.InsulinAverageBasal]: oneWeek,
    [InsightKey.InsulinAverageBolus]: oneWeek,
    [InsightKey.InsulinAverage]: oneWeek,
    [InsightKey.InsulinTotalBasal]: oneDay,
    [InsightKey.InsulinTotalBolus]: oneDay,
    [InsightKey.InsulinTotal]: oneDay,
    [InsightKey.MiniGraph]: sixHours,
    [InsightKey.TimeInRange]: upToNow,
  }
}

export const defaultInsightRangeByKey: Readonly<
  Record<InsightKey, Insight["range"]>
> = copyDefaultInsightRangeByKey()
